import React from 'react';
import { Badge, DisplayText } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';

interface InstructionStepProps {
  step: number;
  description: string;
  className?: string;
}

const InstructionStep: React.FC<InstructionStepProps> = ({
  step,
  description,
  className
}) => {
  return (
    <div className={`flex actr g10 ${className}`}>
      <Badge status="message">
        <FormattedMessage id="common.step" />
        &nbsp;{step}
      </Badge>
      <DisplayText size="large" weight="SemiBold">
        <FormattedMessage id={description} />
      </DisplayText>
    </div>
  );
};

export default InstructionStep;
